import { post } from '@ln/core/pwa/ajax';
import ConfigProvider from '../Core/Configuration/ConfigProvider';
import * as EmailValidator from '../Core/Validators/EmailValidator';

const HOROSCOPO_SERVICIO_ID = 205;

const Newsletter = {
    Initialize() {
        const $newsletter = document.querySelector('.newsletter');

        if ($newsletter === null)
            return;

        const $submit = $newsletter.querySelector('button');

        $submit.addEventListener('click', _OnSubscribeClick);
    }
};

function _OnSubscribeClick(e) {
    e.target.disabled = true;

    const $newsletter = document.querySelector('.newsletter');
    const $emailContainer = $newsletter.querySelector('.newsletter__container__input');
    const $email = $emailContainer.querySelector('input[type="email"]');

    if (!EmailValidator.IsValidEmail($email.value)) {
        $emailContainer.classList.add('--error');
        e.target.disabled = false;
        return;
    }

    $emailContainer.classList.remove('--error');

    const params = {
        email: $email.value,
        serviciosId: [HOROSCOPO_SERVICIO_ID]
    }

    const headers = {
        'Content-Type': 'application/json'
    };

    post(ConfigProvider.ApiNewsletterSuscripcionUrl, params, headers)
        .then(response => _SubscriptionResponse(response))
        .catch(error => _SubscriptionResponse(error));
}

function _SubscriptionResponse(response) {
    const $newsletter = document.querySelector('.newsletter');
    const $button = $newsletter.querySelector('button');
    const $emailContainer = $newsletter.querySelector('.newsletter__container__input');
    const $responseEmail = $newsletter.querySelector('#newsletter-email');
    const $responseMessage = $newsletter.querySelector('#newsletter-msg');

    $button.classList.add('d-none');
    $emailContainer.classList.add('d-none');
    $responseMessage.classList.remove('d-none');

    if (response === undefined || response === null) {
        $responseMessage.innerText = 'Ocurrió un error, por favor intentá más tarde.';
        return;
    }
    
    const code = response.substring(response.indexOf('|') - 1, response.indexOf('|')).trim()
    const email = $emailContainer.querySelector('input[type="email"]').value;

    switch (code) {
        case '0':
            $responseEmail.innerText = email;
            $responseEmail.classList.remove('d-none');
            $responseMessage.innerHTML = '<b>¡Gracias! A partir de ahora recibirás el newsletter.</b>';
            break;
        case '1':
            $responseEmail.innerText = email;
            $responseEmail.classList.remove('d-none');
            $responseMessage.innerHTML = '<b>¡Gracias! Ya estás recibiendo el newsletter.</b>';
            break;
        default:
            $responseMessage.innerText = 'Ocurrió un error, por favor intentá más tarde.';
            break;
    }
}

export default Newsletter;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Newsletter.js